/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

function showFallback(img) {
    const fallback = img.dataset.imgFallback
    if (!fallback || img.src.endsWith(fallback)) {
        return
    }

    img.removeAttribute('srcset')
    img.src = fallback
}

function onError(e) {
    showFallback(e.currentTarget)
}

/**
 * Swap an image for `data-img-fallback` when it fails to load (e.g. a CHILI
 * preview that CHILI no longer serves), instead of showing a broken image and
 * its alt text. Also covers images that already failed before connect.
 *
 * @type {Listener}
 */
export default {
    selector: 'img[data-img-fallback]',
    connect(element) {
        element.addEventListener('error', onError)
        // Already failed before connect. A lazy image not fetched yet has no currentSrc.
        if (element.complete && element.currentSrc && 0 === element.naturalWidth) {
            showFallback(element)
        }

        return () => element.removeEventListener('error', onError)
    },
}
